var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.272 1.199 1.473 2.946 2.834.283a.358.358 0 0 1 .218.61L8.462 7.374l.866 3.172a.36.36 0 0 1-.507.416l-2.87-1.436-2.87 1.437a.357.357 0 0 1-.506-.415l.865-3.174-2.335-2.336a.358.358 0 0 1 .219-.61l2.833-.284L5.63 1.198a.358.358 0 0 1 .642.001Z",
  fill: "#268257",
  stroke: "#268257",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgIcoStar as ReactComponent };
export default __webpack_public_path__ + "assets/media/ico-star.6fb5f9df8d63379fa0db2078f83f24ea.svg";